export { ConsultantSlimBanner } from "./ConsultantSlimBanner";
export type {
	ConsultantSlimBannerProps,
	ConsultantSlimBannerCta,
	HeadingTag
} from "./ConsultantSlimBanner";
export {
	ContactYourConsultant,
	type ContactYourConsultantProps,
	type ContactFormValues
} from "./ContactYourConsultant";
